import {
  coverageWillChangeDescriptionField,
  coverageWillChangeField,
  formatField,
  InsuranceInfo,
} from '@hb/shared'
import { useMemo } from 'react'
import { InsuranceInfoForm } from './InsuranceInfoForm'

import { EditIcon } from '@chakra-ui/icons'
import { Box, Collapse, Flex, IconButton, Text, VStack } from '@chakra-ui/react'
import { useInsuranceInfoStage } from './context'

const CoverageWillChangeComplete = ({
  isComplete,
  insuranceInfoData,
  onEdit,
}: {
  isComplete: boolean
  insuranceInfoData: Partial<InsuranceInfo>
  onEdit: () => void
}) => {
  const coverageWillChangeDescription = useMemo(
    () =>
      formatField(
        coverageWillChangeDescriptionField,
        insuranceInfoData.coverageWillChangeDescription,
      ),
    [insuranceInfoData],
  )

  return (
    <Collapse style={{ width: '100%' }} in={isComplete}>
      <Flex pt={2} gap={1.5} width="100%">
        <VStack
          borderRadius={4}
          bg="white"
          border="1px solid #cdcdcd"
          py={1}
          px={3}
          spacing={1}
          flexFlow="column"
          flex={1}
          minW={0}>
          <Text fontSize="lg">{coverageWillChangeDescription}</Text>
          {/* <DataView
            renderNotes
            noHeader
            data={insuranceInfoData}
            field={coverageWillChangeDetailsField}
          /> */}
        </VStack>
        <IconButton borderRadius="full" onClick={onEdit} icon={<EditIcon />} aria-label="Edit" />
      </Flex>
    </Collapse>
  )
}

export const CoverageWillChange = () => {
  const { insuranceInfoData, onUpdate } = useInsuranceInfoStage()
  const isComplete = useMemo(() => {
    if (!insuranceInfoData.option) return false
    if (insuranceInfoData.option !== 'coverage-will-change') return false
    return !!insuranceInfoData.coverageWillChangeDescription
  }, [insuranceInfoData])
  const isActive = useMemo(
    () => !isComplete && insuranceInfoData.option === 'coverage-will-change',
    [insuranceInfoData, isComplete],
  )

  return (
    <Collapse style={{ width: '100%' }} in={insuranceInfoData.option === 'coverage-will-change'}>
      <Box w="100%" pt={2}>
        <InsuranceInfoForm
          field={coverageWillChangeField}
          data={insuranceInfoData}
          onSubmit={onUpdate}
          isActive={isActive}
        />
        <CoverageWillChangeComplete
          isComplete={isComplete}
          insuranceInfoData={insuranceInfoData}
          onEdit={() => onUpdate({ coverageWillChangeDescription: null })}
        />
      </Box>
    </Collapse>
  )
}
